module.exports = __webpack_public_path__ + "img/associationNodeWhite.8f3a56f2.svg";